import { TimeAgoPipe } from 'components';
import { parseTeamRefusal } from './team-refusal.util';
import { CreditRequest } from './team.types';

const TIME_AGO = new TimeAgoPipe();

/** The control a member presses, worded the same on every surface that offers it. */
export const ASK_FOR_CREDITS_LABEL = 'Ask the master account for credits';

/**
 * "Master account asked · 5 minutes ago" — what replaces the control once the
 * member has asked, on the popover and the Credits page alike.
 */
export function askedForCreditsNote(request: CreditRequest): string {
	return `Master account asked · ${TIME_AGO.transform(request.created_at)}`;
}

/**
 * "asked 5m" — the mark after the member's figure in the owner's Credits cell.
 * Short on purpose: it shares one line of a narrow cell with the balance, and
 * {@link creditRequestMarkTooltip} carries the full sentence on hover.
 */
export function creditRequestMark(request: CreditRequest): string {
	return `asked ${shortAge(request.created_at)}`;
}

/** "Asked for more credits · 5 minutes ago" — the mark's tooltip. */
export function creditRequestMarkTooltip(request: CreditRequest): string {
	return `Asked for more credits · ${TIME_AGO.transform(request.created_at)}`;
}

/** "just now", "5m", "3h", "2d", "3w" — the compact age of a request. */
function shortAge(iso: string): string {
	const minutes = Math.floor((Date.now() - new Date(iso).getTime()) / 60_000);
	if (!Number.isFinite(minutes) || minutes < 1) {
		return 'just now';
	}
	if (minutes < 60) {
		return `${minutes}m`;
	}
	const hours = Math.floor(minutes / 60);
	if (hours < 24) {
		return `${hours}h`;
	}
	const days = Math.floor(hours / 24);
	return days < 7 ? `${days}d` : `${Math.floor(days / 7)}w`;
}

/** Why an ask was refused, in the server's own sentence where it sent one. */
export function askRefusalSentence(error: unknown): string {
	return (
		parseTeamRefusal(error)?.message ??
		'We could not ask the master account just now. Try again in a moment.'
	);
}
